<template lang="pug">
.content-wrap
  .content-top
    .con
      section.fullBg
        template(v-if="!startRender")
          template(v-if="goDepo")
            .step1
              .title
                img(src='/new/img/events/august-2025/lock.png' @click="depoAct")
              .centerBlocks
                img(src='/new/img/events/august-2025/centerBlock.png')
          template(v-else)
            .step1
              .title.custom-font
                .depositPro
                  h2 DEPOSIT PROGRESS
                  .progress-container
                    #myProgressBar.progress-bar(:style="'width:'+depoProgress+'%'")
                    .progressValue ₱{{$numeral(depoAmt).format("0,0")}} / ₱{{$numeral(targetAmt).format("0,0")}}
                  ul
                    li.c1(:class="{'active': tier == 1}")
                      img(:class="{'non-active': tier < 1}" src='/new/img/events/august-2025/1.png')
                      span Free ₱15
                    li.c2(:class="{'active': tier == 2}")
                      img(:class="{'non-active': tier < 2}" src='/new/img/events/august-2025/2.png')
                      span Free ₱35
                    li.c3(:class="{'active': tier == 3}")
                      img(:class="{'non-active': tier < 3}" src='/new/img/events/august-2025/3.png')
                      span Free ₱150
                    li.c4.ms-auto(:class="{'active': tier == 4}")
                      img(:class="{'non-active': tier < 4}" src='/new/img/events/august-2025/4.png')
                      span Free ₱200
                  img(src='/new/img/events/august-2025/claim.png' @click="toInbox")
              .centerBlocks
                template(v-if="depoAmt >= 700")
                  img(:src="'/new/img/events/august-2025/step'+tier+'.png'")
                  a.linkOverlay(href='javascript:void(0)' :class="'t-'+tier" @click="togglePop")
                template(v-else)
                  img(src='/new/img/events/august-2025/centerBlock.png')
            .popupContent.d-flex(v-if="showPop")
              .centerImg
                img(:src="'/new/img/events/august-2025/t'+tier+'.png'")
                a.btnLink(href='javascript:void(0)' @click="claimAct")
        template(v-else)
          .text-white.my-2.text-center
            i.fas.fa-duotone.fa-spinner.fa-spin-pulse
        .container
          .content-padding
            h4 Deposit more, unlock more! Each tier gives you bigger rewards:
            h4 Tier Levels:
            p Level 1: Accumulate ₱700 = Free ₱15
            p Level 2: Accumulate ₱1,500 = Free ₱35
            p Level 3: Accumulate ₱2,500 = Free ₱150
            p Level 4: Accumulate ₱4,500 = Free ₱200
            h4 Bonus Terms:
            ul
              li 6x turnover
              li Max win = Bonus x10
              li All slots only
              li Bonus expires in 7 days
            p Bonus is credited after the event ends based on the final tier reached.
            h4 General Rules:
            ul
              li Max 5 withdrawals/day
              li Min withdrawal: ₱100
              li 1 account per player only
              li Abuse = disqualified
            p EpicWin reserves the right to modify or cancel this promo at any time.
</template>
<script>
export default{
	data(){
		return{
      startRender: false,
			goDepo:true,
      depoAmt:"",
      targetAmt: 4500,
      depoProgress: "",
      tier: 1,
      showPop:false
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    chunkedToday(){
      let chunkSize = 2;
      let result = [];

      for (let i = 0; i < this.resToday.length; i += chunkSize) {
        result.push(this.resToday.slice(i, i + chunkSize));
      }
      return result;
    },
    chunkedPrev(){
      let chunkSize = 2;
      let result = [];

      for (let i = 0; i < this.resPrev.length; i += chunkSize) {
        result.push(this.resPrev.slice(i, i + chunkSize));
      }
      return result;
    }
  },
	watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.goDepo = true
        this.showPop = false
      }else{
        this.tierDeposit()
      }
    }
  },
  mounted() {
    window.scroll(0,0)
    this.tierDeposit()
  },
	methods:{
    openChat(){
      LiveChatWidget.call("maximize");
    },
    togglePop(act){
      this.showPop = !this.showPop
      if(act){
        if(window.innerWidth > 480){
          window.scroll({
            top: 800,
            left: 0,
            behavior: 'smooth'
          })
        }else{
          window.scroll({
            top: 500,
            left: 0,
            behavior: 'smooth'
          })
        }
      }
    },
    claimAct(){
      this.toInbox()
      this.togglePop(1)
    },
    toInbox(){
      if (this.sessionToken) {
        if(this.tier > 0){
          this.$router.push("/inbox").catch(err => {});
        }else{
          return
        }
        
      }
    },
    tierDeposit(){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/depositTrackerv2", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.depoAmt = response.data.info[0].deposit_amount
              this.targetAmt =  response.data.info[0].target_amount
              this.depoProgress = parseFloat(this.depoAmt) / this.targetAmt * 100
              
              if(response.data.info[0].deposit_amount > 0){
                this.goDepo = false
                this.tier = response.data.tier.reduce((acc, item) => item.unlocked ? item.level : acc, 0)
              }else{
                this.goDepo = true
                this.tier = 1
              }
              this.startRender = false
            } else {
              this.startRender = false
              this.goDepo = true
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.startRender = false
            this.goDepo = true
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    
    depoAct(){
      if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				// this.$router.push("/login").catch(err => {});
        this.$helpers.openModal('#logModal')
			}
    }
	}
}
</script>
<style lang="css" scoped>
* {
    box-sizing: border-box;
}

.fullBg {
    background-image: url('/new/img/events/august-2025/bg.jpg');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;

    background-color: #13292e;
    position: relative;
    max-width: 800px;
    margin: auto;
    padding-top: 470px;
}

.title,
.gift,
.lockImg {
    text-align: center;
}



.title img {
    max-width: 90%;
    margin: auto;
}

.title {
    cursor: pointer;
}

.container {
    position: relative;
    padding: 0 10px;
    margin: 0 auto;
    max-width: 1360px;
}

.content-padding {
    /* padding-top: 50px; */
    padding-bottom: 50px;
    color: #fff;
}




.centerBlocks {
    padding-top: 30px;
    position: relative;
}

.centerBlocks img {
    max-width: 98%;
    padding-top: 10px;
    padding-bottom: 30px;
    margin: auto;
    display: block;
}

.linkOverlay {
    position: absolute;
    width: 80%;
    height: 250px;
    display: block;
    bottom: 130px;
    left: 0;
    margin: auto;
    right: 0;
    cursor: pointer;
}

.t-1{

}

.t-2{
  bottom: 380px;
}
.t-3{
  bottom: initial;
  top: 335px;
}
.t-4{
  bottom: initial;
  top: 70px;
}

.actionBtn {
    text-align: center;
    font-size: 26px;
    color: #fff;
    font-weight: 600;
}

.actionBtn img {
    max-width: 400px;
    cursor: pointer;
}

.popupContent {
    background-color: hsl(0deg 0% 0% / 50%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    align-items: center;
}

.popupContent img {
    max-width: 80%;
    margin: auto;
    display: block;
}

.popupContent .centerImg {
    position: relative;
}

.popupContent a {
    position: absolute;
    display: block;
    width: 36%;
    height: 50px;
    bottom: 104px;
    left: 0;
    right: 0;
    margin: auto;
}

.result {
    width: 95%;
    border: 8px solid #61168c;
    margin: auto;
    border-radius: 20px;
    color: #fff;
}

.result table {
    width: 100%;
    font-size: 24px;
}

.result table th,
.result table td {
    padding: 20px;
    font-weight: 800;
    text-align: center;
    text-transform: uppercase;
}

.result table th {
    color: #ffd108;
}

.step2,
.step3,
.step4 {
    display: none;
}

.checkNumber {
    cursor: pointer;
}

.resultView {
    background-image: url('/new/img/events/august-2025/resultbg.png');
    background-size: 100% 100%;
    text-align: center;
    color: #fff;
    padding: 60px;
    margin: 20px 0px;
}

.resultView h3 {
    font-size: 40px;
    font-weight: 900;
    margin: 0px;
}

.resultView h4 {
    font-size: 30px;
    font-weight: 900;
    color: #01ff19;
    margin: 0px;
}

.resultView table {
    width: 100%;
    font-size: 40px;
    font-weight: 800;
}

.resultView table td {
    padding: 10px;
}

.yesterdayReport {
    display: none;
}

.yesterdayPopup .clickTab {
    left: 0;
}

.yesterdayPopup {
    display: none;
}

.actionBtn .winning {
    width: 450px;
    margin-top: 40px;
}


.depositPro {
    background-image: url('/new/img/events/august-2025/progressbarbg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 30px;
    overflow: hidden;
    max-width: 90%;
    margin: auto;
    color: #fff;
    padding: 25px;
}

.depositPro h2 {
    margin: 0px;
    color: #fff;
    /* text-shadow: 1px 1px 2px #754009; */
    text-shadow: -2px -2px 0 #754009,
     2px -2px 0 #754009,
    -2px  2px 0 #754009,
     2px  2px 0 #754009;
    font-size: 26px;
    font-weight: 800;
}

.depositPro ul {
    padding: 0px;
    list-style: none;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    max-width: 90%;
    margin: 20px auto;
    margin-top: 40px;
}

.depositPro ul li span {
    display: block;
    /* text-shadow: 1px 1px 2px #000; */
    text-shadow: -2px -2px 0 #754009,
     2px -2px 0 #754009,
    -2px  2px 0 #754009,
     2px  2px 0 #754009;
    font-size: 15px;
    font-weight: 800;
}

.depositPro ul li img {
    max-width: 80%;
}

.depositPro ul li {
    position: relative;
}

.depositPro ul li:before {
    content: '';
    background-image: url('/new/img/events/august-2025/arrow.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    position: absolute;
    top: -40px;
    left: 0;
    right: 0;
    background-size: 100% auto;
    margin: auto;
}
.depositPro ul .c1 {
    margin-left: 65px;
}
.depositPro ul .c1:before {
    left: 0;
    right: 0;
}
.depositPro ul .c3:before {
    right: -20px;
}

.depositPro ul .c4:before {
    left: auto;
    right: 20px;
}

.depositPro ul .c2:after {
    right: -10px;
}
.depositPro ul .c3:after {
    right: -70px;
}

.non-active,
.depositPro ul li.active~li img {
    opacity: 0.6;
}

.depositPro ul li.active img {
    filter: drop-shadow(2px 2px 10px #fff);
}

.depositPro ul li:after {
    content: '';
    background-image: url('/new/img/events/august-2025/plus.png');
    width: 20px;
    height: 20px;
    display: inline-block;
    position: absolute;
    /* right: -34px; */
    right: -12px;
    background-size: 100% auto;
    margin: auto;
    bottom: 2px;
}

.depositPro ul li:last-child:after {
    display: none;
}


.progress-container {
    width: 100%;
    border-radius: 20px;
    overflow: hidden;
    border: 3px solid #883F14;
    max-width: 80%;
    margin: 10px auto;
    background-color: #C36F3E;
    position: relative;
}

.progress-bar {
    width: 10%;
    height: 30px;
    background-color: #6EA929;
    text-align: center;
    line-height: 30px;
    color: white;
    border-radius: 20px;
    transition: all 0.2s ease-in-out;
}

.progressValue {
    /* text-shadow: 2px 2px 2px #000; */
    text-shadow: -2px -2px 0 #754009,
     2px -2px 0 #754009,
    -2px  2px 0 #754009,
     2px  2px 0 #754009;
    font-size: 23px;
    font-weight: 800;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
}

@media (min-width: 801px) and  (max-width:1100px) {
  .depositPro ul .c3:after {
    right: -13px;
  }

}

@media (max-width:800px) {
    .tabmenu img {
        max-width: 80%;
    }

    .resultView h3 {
        font-size: 17px;
    }

    .resultView h4 {
        font-size: 18px;
    }

    .resultView table {
        font-size: 20px;

    }

    .resultView table td {
        padding: 6px;
    }

    .actionBtn {
        font-size: 18px;
    }

    .actionBtn img {
        max-width: 80%;
    }

    .tabmenu,
    .popupContent .tabmenu img {
        max-width: 80%;
    }

    .popupContent p {
        font-size: 17px;
    }

    .result table {
        font-size: 18px;
    }

    .result table th,
    .result table td {
        padding: 8px;
        font-weight: 700;
    }

    .result {
        border: 5px solid #61168c;
    }

    .title .depositPro img {
        max-width: 100%;
    }
    .depositPro ul{
        max-width: 100%;
    }
    .depositPro ul .c1{
      margin-left: 25px;
    }

    .progress-container{
      max-width: 100%;
    }
    .depositPro ul .c1:before {
      right: -25px;
    }
    .depositPro ul .c2:before {
      right: 20px;
    }
    .depositPro ul .c3:before {
      right: 40px;
    }
    .depositPro ul .c4:before {
      right: -10px;
    }
    .depositPro ul .c2:after,
    .depositPro ul .c3:after{
      right: -7px;
    }
}

@media (max-width:650px){
  .depositPro ul .c1{
    margin-left: 7px;
  }
}


@media (max-width:480px) {
    .linkOverlay {
      height: 120px;
      bottom: 85px;
    }

    .t-1{

    }

    .t-2{
      bottom: 210px;
    }
    .t-3{
      bottom:initial;
      top: 188px;
    }
    .t-4{
      bottom:initial;
      top:58px;
    }

    .fullBg {
        padding-top: 230px;
    }

    .popupContent a {
        bottom: 38px;
    }

    .depositPro {
        padding: 15px;
    }

    .depositPro h2 {
        font-size: 16px;
    }

    .progressValue {
        font-size: 16px;
    }

    .progress-bar {
        height: 20px;
    }

    .depositPro ul li:before {
        width: 20px;
        height: 20px;
        top: -30px;
    }

    .depositPro ul li img {
        max-width: 60%;
    }

    .depositPro ul li span {
        font-size: 11px;
        font-weight: 600;
    }

    .depositPro ul li:after {
        right: -7px;
        width: 12px;
        height: 12px;
        bottom: 0;
    }

    .title .depositPro img {
        max-width: 100%;
    }
    .depositPro ul{
        max-width: 100%;
    }
    .depositPro ul .c1{
      margin-left: 0;
    }

    .progress-container{
      max-width: 100%;
    }
    .depositPro ul .c1:before {
      right: -25px;
    }
    .depositPro ul .c2:before {
      right: 20px;
    }
    .depositPro ul .c3:before {
      right: 40px;
    }
    .depositPro ul .c4:before {
      right: -10px;
    }
    .depositPro ul .c2:after,
    .depositPro ul .c3:after{
      right: -7px;
    }
}

</style>